import { DiagramDefinition } from "../types";

export const m024Definition: DiagramDefinition = {
  id: "M-024",
  title: "Solarch Model Context Protocol (MCP) Architecture",
  description:
    "Architectural diagram of Solarch Model Context Protocol server showing AI assistants and coding agents connecting over JSON-RPC to the MCP Server, passing through Schema and ACL validation to the Solarch backend.",
  viewBox: "0 0 800 380",
  nodes: [
    {
      id: "AIAssistant",
      kind: "client",
      label: "AI Agents & IDEs",
      subtext: "Claude Desktop, Cursor, Cline",
      position: [400, 50],
      size: [250, 50],
    },
    {
      id: "MCPServer",
      kind: "service",
      label: "Solarch MCP Server",
      subtext: "JSON-RPC Protocol & ACL Gate",
      position: [400, 170],
      size: [250, 50],
    },
    {
      id: "SolarchCore",
      kind: "database",
      label: "Solarch Backend Engine",
      subtext: "Dual SQLite WAL, Vectors & Files",
      position: [400, 290],
      size: [260, 52],
    },
  ],
  edges: [
    {
      id: "e1",
      source: "AIAssistant",
      target: "MCPServer",
      sourcePort: "bottom",
      targetPort: "top",
      label: "MCP JSON-RPC (Tools & Resources)",
      animated: true,
      routing: "straight",
    },
    {
      id: "e2",
      source: "MCPServer",
      target: "SolarchCore",
      sourcePort: "bottom",
      targetPort: "top",
      label: "Internal Core Client",
      animated: true,
      routing: "straight",
    },
  ],
};
